/**
 * @generated SignedSource<<84370c9a0620ac04d654b079743d9f08>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductCarouselOnly_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarousel_item">;
  readonly " $fragmentType": "BuyerProductCarouselOnly_item";
};
export type BuyerProductCarouselOnly_item$key = {
  readonly " $data"?: BuyerProductCarouselOnly_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarouselOnly_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductCarouselOnly_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImageCarousel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "698d88501215ca749b2688595cbda6e2";

export default node;
